import { render, staticRenderFns } from "./CanvasViz.vue?vue&type=template&id=5dfb1568&scoped=true&"
import script from "./CanvasViz.vue?vue&type=script&lang=js&"
export * from "./CanvasViz.vue?vue&type=script&lang=js&"
import style0 from "./CanvasViz.vue?vue&type=style&index=0&id=5dfb1568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb1568",
  null
  
)

export default component.exports